// The reply preview the bubble shows is the start of a markdown message: drop the markers so it reads as speech
// ("**25 jobs**" -> "25 jobs", a link keeps its words).
export function plainText(text) {
  return String(text || "")
    .replace(/\[([^\]]+)\]\([^)]*\)/g, "$1")
    .replace(/(\*\*|__|\*|`)/g, "")
    .replace(/^\s{0,3}(#{1,6}|[-*+]|\d+\.)\s+/gm, "")
    .replace(/\s+/g, " ")
    .trim()
}
